<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :model="addForm" ref="addFormRef" :inline="true" label-width="80px" class="font-bold">
        <el-form-item label="客户id" prop="uid" >
          <el-input size="small" v-model="addForm.uid" clearable placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getEvaluateList(true)">搜索</el-button>
          <el-button size="small" @click="resetInput">重置</el-button>
        </el-form-item>

      </el-form>

      <el-table :data="evaluate" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="客服id" prop="Cid" width="80%"></el-table-column>
        <el-table-column label="客服名称" prop="Cname"></el-table-column>
        <el-table-column label="平均满意度" prop="AvgScore"></el-table-column>
        <el-table-column label="平均每次服务时长" prop="AvgWorkHours"></el-table-column>
        <el-table-column label="总服务时长" prop="TotalWorkHours"></el-table-column>
        <el-table-column label="直接服务次数" prop="TotalTimes"></el-table-column>
        <el-table-column label="转接次数" prop="TransferTimes"></el-table-column>
        <el-table-column label="总服务次数" prop="TotalCounts"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
  import { chat_get } from '@/api'
  import {formatTime} from '@/utils'

  export default {
    name: 'allEvaluate',
    data() {
      return {
        // 获取角色列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        evaluate: [],
        total: 0,
        addForm: {
          uid: '',
          status: '',
        },
      }
    },
    created() {
      this.getEvaluateList()
    },
    methods: {
      getEvaluateList(val = false) {
        if (val) this.queryInfo.pagenum = 1;
        let { uid, status } = this.addForm;
        chat_get(`/admin/v1/evalList?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&uid=${uid}&status=${status}`, {}, res => {
          if (res.status == 200) {
            let eva = res.data.PageEvaluationRecordMes;
            eva.map(item => {
              return (
                item.TotalWorkHours = formatTime(parseInt(item.TotalWorkHours)),
                item.AvgWorkHours = formatTime(parseInt(item.AvgWorkHours))
              )
            })
            this.evaluate = eva;
            this.total = res.data.Count;
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getEvaluateList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getEvaluateList()
      },
      resetInput() {
        this.$refs.addFormRef.resetFields()
        this.getEvaluateList()
      },
    }
  }
</script>

<style scoped>
  .el-icon-circle-close {
    color: white !important;
  }
</style>
